import { render, staticRenderFns } from "./HoSoCaNhan.vue?vue&type=template&id=6b4cd017&scoped=true"
import script from "./HoSoCaNhan.vue?vue&type=script&lang=js"
export * from "./HoSoCaNhan.vue?vue&type=script&lang=js"
import style0 from "./HoSoCaNhan.vue?vue&type=style&index=0&id=6b4cd017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4cd017",
  null
  
)

export default component.exports